module.exports = __webpack_public_path__ + "img/sesame.952da20b.svg";